export default __webpack_public_path__ + "static/media/figma.6c172f30.svg";